export const SET_ORGANIZATION_DONATION = 'donation/SET_ORGANIZATION_DONATION';
